/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Models an OpenAPI 3.0.x authorization code oauth flow.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends AuthorizationCodeOAuthFlow
 */
export class Oas30AuthorizationCodeOAuthFlow extends AuthorizationCodeOAuthFlow {
    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitAuthorizationCodeOAuthFlow(this);
    }

    constructor() {
        super();
    }
}
Oas30AuthorizationCodeOAuthFlow["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30AuthorizationCodeOAuthFlow";
Oas30AuthorizationCodeOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




